import React, { useState } from "react";
import PrivacyPolicyModal from "./modals/PrivacyPolicyModal";
import { frontendVersion } from "../config/environment";

interface FooterProps {
  backendVersion?: string | null;
}

const Footer: React.FC<FooterProps> = ({ backendVersion }) => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  return (
    <>
      <footer className="bg-[#e3f2fd] py-4 text-center text-xs text-gray-400 select-none">
        <div className="flex flex-col items-center space-y-1">
          <span>
            ©2025 Meditrina, Inc. or its affiliates. Aveta® is a registered
            trademark of Meditrina, Inc. All rights reserved. See our{" "}
            <button
              onClick={() => setShowPrivacyModal(true)}
              className="text-[#46ACC6] hover:text-[#3a8ba3] hover:underline transition-colors"
              type="button"
            >
              Privacy Policy
            </button>
            . REF#: 230-2057. G: {frontendVersion}
            {backendVersion && ` | S: ${backendVersion}`}
          </span>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
      />
    </>
  );
};

export default Footer;
